import { categoryWidth, bidWidth } from './shared-constant';

export const getCategoryTargetStyles = () => ({
  listHeader: {
    display: 'flex',
    gap: '10px',
    alignItems: 'start',
    padding: '10px 0',
    '& .category-label': {
      width: categoryWidth,
    },
    '& .bid': {
      width: bidWidth,
    },
  },
});
